import React from "react";
import { Redirect } from "react-router-dom";

import AppHeading from "2g-app-heading";
import { Route, Switch, useRouterProvider } from "2g-router";
import { Logos } from "2g-icons";

import { PATHS, PAGE_TITLES } from "b2b/constants";
import { useFetchErrorMessage, useUserInfoLang } from "b2b/hooks";

import AppFooter from "./components/app-footer/AppFooter";
import Administrace from "b2b/pages/administrace/Administrace";
import Prehled from "b2b/pages/Prehled";
import ProvozniInformace from "b2b/pages/provozni-informace/ProvozniInformace";
import ProvozniInformaceEditace from "b2b/pages/provozni-informace/ProvozniInformaceEditace";
import ProvozniInformaceDetail from "b2b/pages/provozni-informace/ProvozniInformaceDetail";
import Rezervace from "b2b/pages/rezervace/Rezervace";
import ZadostDetail from "b2b/pages/zadosti/ZadostDetail";
import NotFound from "b2b/components/NotFound";
import ComponentsExample from "b2b/examples/ComponentsExample";
import { Unauthorized } from "b2b/components/auth";
import useRezervaceVytvoreniFormLogoutDestroy from "b2b/components/rezervace-vytvoreni/hooks/useRezervaceVytvoreniFormLogoutDestroy";

import AppNavigation from "./AppNavigation";
import AppControl from "./AppControl";

export function App() {
  useFetchErrorMessage();
  useUserInfoLang();
  useRezervaceVytvoreniFormLogoutDestroy();
  const { getLangPath, getLangsPaths } = useRouterProvider();

  return (
    <>
      <AppHeading
        logo={<Logos.VUZLogo />}
        name="B2B Portál"
        control={<AppControl />}
      >
        <AppNavigation />
      </AppHeading>
      <div>
        <Switch>
          <Route exact path={PATHS.BASE}>
            <Redirect to={getLangPath(PATHS.PREHLED)} />
          </Route>
          <Route exact path={getLangsPaths(PATHS.REZERVACE.BASE)}>
            <Redirect to={getLangPath(PATHS.REZERVACE.CASOVY_PLAN)} />
          </Route>
          <Route
            exact
            path={getLangsPaths(PATHS.ADMINISTRACE.BASE)}
            role={["admin", "vuz_spravce"]}
          >
            <Redirect to={getLangPath(PATHS.ADMINISTRACE.ZAKAZNICI)} />
          </Route>

          <Route path={PATHS.PREHLED} title={PAGE_TITLES.PREHLED}>
            <Prehled />
          </Route>

          <Route
            exact
            path={PATHS.PROVOZNI_INFORMACE.LIST}
            title={PAGE_TITLES.PROVOZNI_INFORMACE}
          >
            <ProvozniInformace />
          </Route>
          <Route
            exact
            path={PATHS.PROVOZNI_INFORMACE.VYTVORENI}
            title={PAGE_TITLES.PROVOZNI_INFORMACE_NOVA}
            role={["admin", "vuz_spravce", "vuz_edit"]}
          >
            <ProvozniInformaceEditace />
          </Route>
          <Route
            exact
            path={PATHS.PROVOZNI_INFORMACE.DETAIL}
            title={PAGE_TITLES.PROVOZNI_INFORMACE_DETAIL}
          >
            <ProvozniInformaceDetail />
          </Route>
          <Route
            exact
            path={PATHS.PROVOZNI_INFORMACE.EDITACE}
            title={PAGE_TITLES.PROVOZNI_INFORMACE_EDITACE}
            role={["admin", "vuz_spravce", "vuz_edit"]}
          >
            <ProvozniInformaceEditace />
          </Route>

          <Route path={PATHS.REZERVACE.BASE}>
            <Rezervace />
          </Route>

          <Route path={PATHS.ADMINISTRACE.BASE} role={["admin", "vuz_spravce"]}>
            <Administrace />
          </Route>

          <Route path={PATHS.ZADOSTI.DETAIL}>
            <ZadostDetail />
          </Route>

          <Route path={PATHS.COMPONENTS} role={["admin"]}>
            <ComponentsExample />
          </Route>

          <Route path={PATHS.UNAUTHORIZED}>
            <Unauthorized />
          </Route>

          <Route path={PATHS.NOT_FOUND}>
            <NotFound />
          </Route>
        </Switch>
      </div>
      <AppFooter />
    </>
  );
}

export default App;
